'use client';

import { MarketSelectorDropdown } from '@components/MarketSelector';
import { useHeaderContext } from '@context/headerContext';

import ServicePopup from './ServicePopup';
import StorePopup from './StorePopup';
import Link from '@app/_components/Link';

const RightLinks = () => {
    const { stores, services, locale, rightLinksCollection } =
        useHeaderContext();

    return (
        <div className="hidden flex-1 items-center justify-end lg:flex">
            {services && Boolean(services.length) && (
                <ServicePopup locale={locale} services={services} />
            )}
            {stores && Boolean(stores.length) && <StorePopup stores={stores} />}
            {rightLinksCollection?.items?.map(
                (item, index) =>
                    item && (
                        <Link
                            key={item.sys.id + index}
                            href={item.externalLink ?? item.internalLink?.slug}
                            locale={locale}
                            className="flex items-center gap-x-1 whitespace-nowrap px-3 hover:underline"
                            target={item.openInNewTab ? '_blank' : undefined}>
                            {item.title}
                        </Link>
                    ),
            )}
            <MarketSelectorDropdown />
        </div>
    );
};

RightLinks.displayName = 'RightLinks';

export default RightLinks;
